import { gsap } from '../utils/gsap';

export function initLoader() {
  const loader = document.querySelector('.loader');
  if (!loader) return;

  const isHome = window.location.pathname === '/';
  if (!isHome) {
    gsap.set(loader, { display: 'none' });
    return;
  }

  const tl = gsap.timeline();

  tl.to(loader, { autoAlpha: 0, duration: 0.5, delay: 1 })
    .set(loader, { display: 'none' });
}